import { Skeleton } from '../../../../Skeleton'

import * as styles from '../RequestProfileTabActivitiesSkeleton.module.css'

function RequestProfileTabActivitiesSkeletonPhaseHeader() {
  return (
    <div className={styles.phaseHeader}>
      <div className={styles.headerRow}>
        <div className={styles.headerLeft}>
          <Skeleton className={styles.chevronSkeleton} />
          <Skeleton className={styles.titleSkeleton} />
        </div>
        <div className={styles.headerRight}>
          <Skeleton className={styles.metaSkeletonCounter} />
          <Skeleton className={styles.metaSkeletonWithIcon} />
          <Skeleton className={styles.metaSkeletonWithIcon} />
          <Skeleton className={styles.metaSkeletonIcon} />
        </div>
      </div>
    </div>
  )
}

export default RequestProfileTabActivitiesSkeletonPhaseHeader
